export type CatalogProduct = {
  name: string
  slug: string
  href: string
  image: string
  category: string
  price: number
  description: string
}

export const catalogProducts: CatalogProduct[] = [
  {
    name: 'Kumaş Kaplı Akustik Panel',
    slug: 'kumas-kapli-akustik-panel',
    href: '/urun/kumas-kapli-akustik-panel/',
    image: '/images/kumas-kapli-akustik-panel.webp',
    category: 'Akustik Paneller',
    price: 995,
    description:
      'Kumaş kaplı akustik panel ürünümüz yankıyı azaltan performans, modern görünüm ve uzun ömürlü kullanım için üretilir.',
  },
  {
    name: 'Akustik Ahşap Panel',
    slug: 'akustik-ahsap-panel',
    href: '/urun/akustik-ahsap-panel/',
    image: '/images/akustik-ahsap-panel.webp',
    category: 'Akustik Paneller',
    price: 1995,
    description:
      'Akustik ahşap panel ürünümüz mimari yüzey dili ile ses soğurmasını bir arada sunar.',
  },
  {
    name: 'Delikli Ahşap Panel',
    slug: 'delikli-ahsap-panel',
    href: '/urun/delikli-ahsap-panel/',
    image: '/images/ahsap-delikli-panel.webp',
    category: 'Akustik Paneller',
    price: 1795,
    description:
      'Delikli ahşap panel ürünümüz frekans kontrolü ve prestijli ahşap görünüm için üretilir.',
  },
  {
    name: '3D Akustik Panel',
    slug: '3d-akustik-panel',
    href: '/urun/3d-akustik-panel/',
    image: '/images/3d-akustik-panel-main.webp',
    category: 'Akustik Paneller',
    price: 1185,
    description:
      '3D akustik panel ürünümüz üç boyutlu yüzey formu ile hem görsel hem akustik katkı sağlar.',
  },
  {
    name: 'Akustik Keçe Panel',
    slug: 'akustik-kece-panel',
    href: '/urun/akustik-kece-panel/',
    image: '/images/akustik-kece-panel.webp',
    category: 'Akustik Paneller',
    price: 345,
    description:
      'Akustik keçe panel ürünümüz modern kesimli yüzeyler ve hızlı montaj için üretilir.',
  },
  {
    name: 'Akustik Baffle Panel',
    slug: 'akustik-baffle-panel',
    href: '/urun/akustik-baffle-panel/',
    image: '/images/akustik-baffle-panel.webp',
    category: 'Akustik Paneller',
    price: 595,
    description:
      'Akustik baffle panel ürünümüz yüksek tavanlı alanlarda yankıyı yukarıdan kontrol eder.',
  },
  {
    name: 'Akustik Paravan',
    slug: 'akustik-paravan',
    href: '/urun/akustik-paravan/',
    image: '/images/akustik-paravan.webp',
    category: 'Akustik Paneller',
    price: 2745,
    description:
      'Akustik paravan ürünümüz açık ofislerde konuşma mahremiyeti ve esnek bölme için üretilir.',
  },
  {
    name: 'Masa Seperatörü',
    slug: 'masa-seperatoru',
    href: '/urun/masa-seperatoru/',
    image: '/images/masa-seperatoru.webp',
    category: 'Akustik Paneller',
    price: 1315,
    description:
      'Masa seperatörü ürünümüz masaüstü ses kontrolü ve görsel ayrım için üretilir.',
  },
]

export function formatTryPrice(price: number) {
  return (
    new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price) + '₺'
  )
}

export const akustikPanellerIntro = `
<p><strong>Akustik paneller</strong>, iç mekânlarda yankıyı azaltmak, konuşma anlaşılırlığını yükseltmek ve gürültü yükünü düşürmek için üretilen ses emici yüzeylerdir. Doku Akustik olarak kumaş kaplı, ahşap, delikli ahşap, 3D, keçe, baffle, paravan ve masa seperatörü ürünlerini kendi tesisimizde ölçüye özel üretiyoruz. Ofis, çağrı merkezi, stüdyo, konferans salonu ve yaşam alanlarında aynı kalite dilini sürdürüyoruz.</p>
`

export const akustikPanellerFaqs = [
  {
    question: 'Akustik paneller hangi mekânlarda kullanılır?',
    answer:
      'Akustik paneller ofis, açık ofis, çağrı merkezi, toplantı odası, konferans salonu, müzik stüdyosu, sinema, tiyatro, sınıf, kütüphane, restoran, kafe, otel lobisi, hastane bekleme alanı, fabrika ofisi ve ev sinema odalarında kullanılır. Ortak nokta sert yüzeylerin yarattığı yankı ve konuşma karmaşasıdır. Doku Akustik’te mekân tipine göre paneli seçeriz. Konuşma yoğun alanlarda kumaş kaplı akustik paneller, mimari duvarlarda ahşap ve delikli ahşap paneller, yüksek tavanlarda baffle paneller, grafik yüzey isteyen lobilerde keçe paneller öne çıkar. Aynı projede birden fazla tip de birlikte planlanabilir. Amaç her köşeye aynı paneli basmak değil, akustik paneller ile gerçekten duyulan konforu kurmaktır.',
  },
  {
    question: 'Akustik paneller ile ses yalıtım panelleri aynı şey midir?',
    answer:
      'Hayır. Akustik paneller mekânın içindeki yankıyı, çınlamayı ve reverberasyonu yönetir. Ses yalıtım panelleri ise sesin duvar, tavan veya döşemeden başka bir mekâna geçişini azaltmayı hedefler. Bir toplantı odasında hem içeride yankı hem dışarıya sızıntı varsa ikisi birlikte düşünülür. Yalnızca akustik paneller sipariş etmek mahremiyet sorununu tek başına çözmez. Yalnızca yalıtım yapmak da odanın içindeki uğultuyu bitirmez. Biz keşifte önce şikâyeti ayırırız. Yankı baskınsa absorpsiyon panelleri, sızıntı baskınsa yalıtım detayları öne çıkar. Doğru beklenti kurulunca hem ürün seçimi hem bütçe netleşir.',
  },
  {
    question: 'Akustik paneller fiyatları neye göre değişir?',
    answer:
      'Akustik paneller fiyatları panel tipi, ölçü, kalınlık, yüzey kaplaması, yangın sınıfı, montaj yöntemi ve metrajına göre değişir. Kumaş kaplı modellerde kumaş kalitesi ve özel renk üretimi etkiler. Ahşap ve delikli ahşap panellerde ahşap türü ile delik deseni belirleyicidir. Keçe panellerde densite ve form kesimi, baffle sistemlerinde asım aksesuarı ve işçilik maliyeti değiştirir. Büyük ofis ve çağrı merkezi projelerinde metrekare arttıkça birim maliyet avantajı doğabilir. Bu sayfadaki fiyatlar başlangıç referansıdır. Net teklif keşif ve ölçü sonrası yazılır. Amacımız sürpriz çıkmayan, kalem kalem okunabilir bir fiyatlandırmadır.',
  },
  {
    question: 'Akustik paneller montajı ne kadar sürer?',
    answer:
      'Montaj süresi alan büyüklüğüne, panel tipine ve saha hazırlığına bağlıdır. Tipik bir toplantı odası veya küçük ofis uygulaması çoğu zaman birkaç gün içinde tamamlanır. Çağrı merkezi, otel lobisi veya çok katlı ofis gibi işlerde etaplı plan çıkarılır. Önce kritik odalar, sonra ortak alanlar biter. Akustik paneller üretimimiz ölçüye özel olduğu için saha fire oranı düşer ve montaj hızlanır. Tavan baffle uygulamalarında kot ayarı ve asım sistemi ek süre ister. Duvar panellerinde hizalama ve köşe detayı kaliteyi belirler. Keşif sonrası net takvim paylaşırız.',
  },
  {
    question: 'Akustik paneller yangın sınıfı ve temizlik açısından nasıl?',
    answer:
      'Doku Akustik üretimlerinde projeye uygun yangın sınıfı hedefleriyle ilerleriz. Kumaş, keçe ve ahşap yüzeylerde ihtiyaç duyulan standartlar teklif aşamasında netleştirilir. Temizlik tarafında kumaş kaplı akustik paneller hafif nemli bezle silinebilir. Keçe panellerde üretici bakım önerilerine göre kuru veya hafif nemli temizlik uygulanır. Ürünlerimiz nem tutmayan, nefes alan yapılarla üretilir. Zamanla koku yapacak şekilde tasarlanmaz. Yoğun kullanım alanlarında doğru yüzey seçimi bakımı da kolaylaştırır. Hastane, okul ve otel gibi yapılarda temizlik protokolüne uygun kaplama tercih edilir.',
  },
  {
    question: 'Hangi akustik paneller ofis için daha doğru olur?',
    answer:
      'Ofiste ihtiyaç konuşma anlaşılırlığı ve odaklanmadır. Açık ofiste kumaş kaplı akustik paneller, akustik paravan ve masa seperatörü birlikte iyi sonuç verir. Yönetim katında ahşap akustik paneller daha prestijli bir dil kurar. Yüksek tavanlı ortak alanlarda baffle paneller yankıyı yukarıdan keser. Cam cepheli ofislerde duvar alanı sınırlıysa tavan panelleri daha verimli olabilir. Biz ofis akustiğini tek ürüne indirgemeyiz. Çalışma düzeni, kişi yoğunluğu ve görsel dil birlikte okunur. Sonra akustik paneller gamından doğru kombinasyon kurulur.',
  },
  {
    question: 'Akustik paneller özel ölçüde ve özel renkte üretilir mi?',
    answer:
      'Evet. Yerli üretici olduğumuz için ölçüye özel kesim ve özel renk taleplerini kendi tesisimizde karşılıyoruz. Kumaş kaplı modellerde kurumsal renklere yakın üretim yapılabilir. Keçe panellerde özel form kesimleri mümkündür. Ahşap panellerde ebat ve delik deseni projeye göre ayarlanır. Bu esneklik şantiyesi ilerleyen işlerde kritiktir. Çünkü son anda çıkan kolon, kapı veya aydınlatma detayı stoğa mahkûm bir ürünle çözülmez. Akustik panellerimizi proje çizimine göre etiketleyip sahaya göndeririz. Böylece montaj ekibi doğru paneli doğru yere yerleştirir.',
  },
  {
    question: 'Akustik paneller sipariş sürecinde keşif zorunlu mudur?',
    answer:
      'Küçük ve net ölçülü işlerde plan üzerinden ilerlemek mümkündür. Yine de doğru akustik paneller seçimi için keşif büyük avantaj sağlar. Keşifte tavan yüksekliği, cam oranı, mevcut kaplamalar, kişi yoğunluğu ve kullanım senaryosu okunur. Yankı mı baskın, sızıntı mı baskın netleşir. Sonra ürün tipi, metraj ve montaj yöntemi yazılır. Ücretsiz keşif ve danışmanlık ile başlarız. Teklif onayından sonra üretim planı oluşur. Sepete eklediğiniz ürünler talep listesi gibi de okunabilir. Büyük projelerde keşif sonrası revizyon normaldir ve yerli üretim sayesinde hızlı döner.',
  },
] as const
